import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { authApi } from "@/api";
import Sidebar from "./Sidebar";

export default function AppShell() {
  const navigate = useNavigate();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["auth-me"],
    queryFn: () => authApi.me(),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (!isLoading && (isError || !data)) {
      navigate("/login", { replace: true });
    }
  }, [isLoading, isError, data, navigate]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-100">
        <p className="text-slate-500">読み込み中...</p>
      </div>
    );
  }

  if (isError || !data) {
    return null;
  }

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <main className="flex-1 p-6 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
